"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WifiProvisioningStatusResponseT = exports.WifiProvisioningStatusResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const wifi_provisioning_status_js_1 = require("../../solarxr-protocol/rpc/wifi-provisioning-status.js");
class WifiProvisioningStatusResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsWifiProvisioningStatusResponse(bb, obj) {
        return (obj || new WifiProvisioningStatusResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsWifiProvisioningStatusResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new WifiProvisioningStatusResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    status() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : wifi_provisioning_status_js_1.WifiProvisioningStatus.NONE;
    }
    static startWifiProvisioningStatusResponse(builder) {
        builder.startObject(1);
    }
    static addStatus(builder, status) {
        builder.addFieldInt8(0, status, wifi_provisioning_status_js_1.WifiProvisioningStatus.NONE);
    }
    static endWifiProvisioningStatusResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createWifiProvisioningStatusResponse(builder, status) {
        WifiProvisioningStatusResponse.startWifiProvisioningStatusResponse(builder);
        WifiProvisioningStatusResponse.addStatus(builder, status);
        return WifiProvisioningStatusResponse.endWifiProvisioningStatusResponse(builder);
    }
    unpack() {
        return new WifiProvisioningStatusResponseT(this.status());
    }
    unpackTo(_o) {
        _o.status = this.status();
    }
}
exports.WifiProvisioningStatusResponse = WifiProvisioningStatusResponse;
class WifiProvisioningStatusResponseT {
    constructor(status = wifi_provisioning_status_js_1.WifiProvisioningStatus.NONE) {
        this.status = status;
    }
    pack(builder) {
        return WifiProvisioningStatusResponse.createWifiProvisioningStatusResponse(builder, this.status);
    }
}
exports.WifiProvisioningStatusResponseT = WifiProvisioningStatusResponseT;
